// src/components/RequestsTable.js
import { useState } from "react";
import { FaTimes } from "react-icons/fa";
import "./RequestsTable.css";
import { BASE_URL } from "../../constants";

const RequestsTable = ({
  title,
  requests,
  reloadRequests,
  onAccept,
  onReject,
  showActions,
}) => {
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [file, setFile] = useState(null);

  const handleViewRequest = (req) => {
    setSelectedRequest(req);
    setIsModalOpen(true);
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file || !selectedRequest) {
      alert("Please upload the file to continue!");
      return;
    }
    // const formData = new FormData();
    // formData.append("document", file);

    try {
      // Upload the file
      //   const uploadResponse = await fetch(
      //     `/api/requests/${selectedRequest.request_id}/upload`,
      //     {
      //       method: "POST",
      //       body: formData,
      //     }
      //   );

      //   if (!uploadResponse.ok) throw new Error("File upload failed");

      // Mark request as complete
      const completeResponse = await fetch(
        `${BASE_URL}/api/requests/${selectedRequest.request_id}/complete`,
        {
          method: "PUT",
        }
      );

      if (!completeResponse.ok) throw new Error("Failed to update status");

      alert("Document uploaded!");
      setIsModalOpen(false);
      setFile(null);

      await reloadRequests(); // if you have access to this function
    } catch (err) {
      alert("Error uploading file or updating status!");
      console.error("Error uploading file or updating status:", err);
    }
  };

  return (
    <div className="arq-page-container">
      <h1>{title}</h1>
      <div className="arq-table-container">
        <table className="arq-styled-table">
          <thead>
            <tr>
              <th>Client Name</th>
              <th>Requested By</th>
              <th>Accident Date</th>
              <th>Nature of Accident</th>
              <th>Policy/Claim Number</th>
              <th>Urgent</th>
              {showActions && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {requests.length > 0 ? (
              requests.map((req) => (
                <tr key={req.request_id}>
                  <td>{req.client_full_name}</td>
                  <td>{req.requested_by_full_name}</td>
                  <td>
                    {new Date(req.accident_date).toLocaleDateString("en-gb")}
                  </td>
                  <td>{req.nature_of_accident}</td>
                  <td>{req.policy_number}</td>
                  <td>{req.is_urgent ? "Yes" : "No"}</td>
                  {showActions && (
                    <td>
                      {onAccept && onReject ? (
                        <>
                          <button
                            className="arq-button"
                            style={{ background: "#4CAF50" }}
                            onClick={() => onAccept(req)}
                          >
                            Accept
                          </button>
                          <button
                            className="arq-button"
                            style={{
                              background: "#f44336",
                              marginLeft: "6px",
                            }}
                            onClick={() => onReject(req)}
                          >
                            Reject
                          </button>
                        </>
                      ) : (
                        <button
                          className="arq-button"
                          onClick={() => handleViewRequest(req)}
                        >
                          View / Upload
                        </button>
                      )}
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={showActions ? "7" : "6"}>
                  <div className="arq-empty-state">
                    <div className="arq-empty-icon">📂</div>
                    <div className="arq-empty-text">No requests available</div>
                    <div className="arq-empty-subtext">
                      When there are new requests, they will appear here.
                    </div>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {isModalOpen && selectedRequest && (
        <div className="arq-modal-overlay">
          <div className="arq-modal">
            {/* Close X button */}
            <button
              className="arq-modal-close"
              onClick={() => setIsModalOpen(false)}
            >
              <FaTimes />
            </button>

            <h2>Request #{selectedRequest.request_id}</h2>

            <p>
              <strong>Client:</strong> {selectedRequest.client_first_name}{" "}
              {selectedRequest.client_last_name}
            </p>
            <p>
              <strong>Requested By:</strong>{" "}
              {selectedRequest.requested_by_full_name}
            </p>
            <p>
              <strong>Nature of Accident:</strong>{" "}
              {selectedRequest.nature_of_accident}
            </p>
            <p>
              <strong>Policy/Claim Number:</strong>{" "}
              {selectedRequest.policy_number}
            </p>
            <p>
              <strong>Urgent:</strong>{" "}
              {selectedRequest.is_urgent ? "Yes" : "No"}
            </p>

            <div className="arq-upload-section">
              <div
                className="arq-file-drop-zone"
                onClick={() =>
                  document.getElementById("hiddenFileInput").click()
                }
              >
                {file ? (
                  <span>📄 {file.name}</span>
                ) : (
                  <span>📂 Click or Tap here to select a file</span>
                )}
              </div>
              <input
                id="hiddenFileInput"
                type="file"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <button className="arq-button" onClick={handleUpload}>
                Upload Document
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RequestsTable;
